import {get} from './request'
import {Page, PageRequest} from "@/model/Page";
import {AppConfigDatasourceDetail, AppConfigDatasourcePreviewItem} from "@/model/AppConfigDatasource";

const proxyUrl = process.env.VUE_APP_BASE_URL + '/app_config'


export interface AppConfigDatasourceItemPageRequest extends PageRequest {
    datasourceId: string
}


export default {
    detail: (id: string): Promise<AppConfigDatasourceDetail> => get(`${proxyUrl}/datasources/one?id=${id}`),

    itemPage: (data: AppConfigDatasourceItemPageRequest): Promise<Page<AppConfigDatasourcePreviewItem>> => get(`${proxyUrl}/datasources/items`, data),
}
